import styled from "styled-components";

export const Cardy = styled.div`
  width: 80%;
  align-items: center;
  justify-content: center;
  margin: auto;
  background-color: black;
  padding-bottom: 50px;
`;

export const Wrapper = styled.div`
  background-color: black;
  padding-top: 10vh;
`;

export const TopLine = styled.div`
  color: white;
  font-size: 40px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 1.4px;
  margin-bottom: 25px;
  text-align: center;
`;
